import React, { useEffect, useState } from "react";
import { MdOutlineCloudDownload } from "react-icons/md";
import { toast } from "react-hot-toast";
import { BiChevronDown, BiPlus } from "react-icons/bi";
import Layout from "../Layout";
import { Button, Select } from "../components/Form";
import { MedicineTable } from "../components/Tables";
import { sortsDatas } from "../components/Datas";
import AddEditMedicineModal from "../components/Modals/AddEditMedicine";
import medicineService from "../api/medicineService";

function Medicine() {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({});
  const [status, setStatus] = useState(sortsDatas.stocks[0]);
  const [medicines, setMedicines] = useState([]);
  const [search, setSearch] = useState("");

  const fetchMedicines = async () => {
    try {
      const res = await medicineService.getAllMedicines(search, status.name);
      // Backend returns { success: true, count, total, data: [] }
      // Or just array depending on implementation?
      // Checking my medicineController: res.status(200).json({ success: true, ..., data: medicines })
      if (res.success) {
        // Map backend 'inStock' to frontend 'stock' expecting component
        const mappedData = res.data.map((item) => ({
          ...item,
          stock: item.inStock, // Map inStock to stock for Table
          id: item._id, // Ensure id is accessible
        }));
        setMedicines(mappedData);
      }
    } catch (error) {
      toast.error("Failed to fetch medicines");
    }
  };

  useEffect(() => {
    fetchMedicines();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, search]); // Re-fetch when status or search changes

  const onCloseModal = () => {
    setIsOpen(false);
    setData({});
  };

  const onEdit = (datas) => {
    setIsOpen(true);
    setData(datas);
  };

  const handleExport = async () => {
    try {
      const blob = await medicineService.exportMedicinesPdf();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Medicines-${Date.now()}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      toast.error("Export failed");
    }
  };

  const onDelete = async (item) => {
    try {
      const res = await medicineService.deleteMedicine(item.id);
      if (res.success) {
        toast.success(res.message);
        fetchMedicines();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Failed to delete medicine");
    }
  };

  return (
    <Layout>
      {isOpen && (
        <AddEditMedicineModal
          datas={data}
          isOpen={isOpen}
          closeModal={onCloseModal}
          onRefresh={fetchMedicines}
        />
      )}
      {/* add button */}
      <button
        onClick={() => setIsOpen(true)}
        className='flex-colo button-fb fixed bottom-8 right-12 z-50 h-16 w-16 animate-bounce rounded-full border border-border bg-[#0095D9] text-white'
      >
        <BiPlus className='text-2xl' />
      </button>
      {/*  */}
      <h1 className='text-xl font-semibold'>Medicine</h1>
      <div
        data-aos='fade-up'
        data-aos-duration='1000'
        data-aos-delay='100'
        data-aos-offset='200'
        className='my-8 rounded-xl border-[1px] border-border bg-white p-5'
      >
        {/* datas */}

        <div className='grid grid-cols-1 gap-2 md:grid-cols-6'>
          <div className='grid items-center gap-2 xs:grid-cols-2 md:col-span-5 lg:grid-cols-4'>
            <input
              type='text'
              placeholder='Search "paracetamol"'
              className='h-14 w-full rounded-md border border-border bg-dry px-4 text-sm text-main'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Select
              selectedPerson={status}
              setSelectedPerson={setStatus}
              datas={sortsDatas.stocks}
            >
              <div className='flex-btn w-full rounded-lg border border-border bg-dry p-4 text-sm font-light text-main focus:border focus:border-[#0095D9]'>
                {status.name} <BiChevronDown className='text-xl' />
              </div>
            </Select>
          </div>

          {/* export */}
          <Button
            label='Export'
            Icon={MdOutlineCloudDownload}
            onClick={handleExport}
          />
        </div>
        <div className='mt-8 w-full overflow-x-scroll'>
          <MedicineTable data={medicines} onEdit={onEdit} onDelete={onDelete} />
        </div>
      </div>
    </Layout>
  );
}

export default Medicine;
